export default __webpack_public_path__ + "static/media/logo-light.d9a5d1b5.svg";